import React from "react";
import { MenuItem } from "@mui/material";
import { translate } from "../../../providers";
import { CustomTooltip } from "../../tooltip";
import styles from "./Selector.module.css";
import { IconComponent } from "../../icon-component";
import { getFilteredDataAttributes } from "../../../utils";
import CustomTextField from "../custom-text-field/CustomTextField";

export default function Selector({
	autoTranslate = "yes",
	className = "",
	disabled = false,
	error = false,
	extraField = "",
	field = null,
	fallbackField = field,
	fullWidth = false,
	icon = "",
	inputClassName = "",
	itemRenderer = (itemLabel) => itemLabel,
	items,
	label,
	labelClassName = "",
	listClassName = "",
	onChange,
	required = false,
	size = "medium",
	textFieldClassName = "",
	value,
	valueRenderer = null,
	withNone = false,
	placeholder = "",
	...dataAttributes
}) {
	const filteredDataAttributes = getFilteredDataAttributes(dataAttributes);
	const handleChange = (e) => {
		e.stopPropagation();
		if ((!e.target?.value && !withNone) || e.target.value?.disabled) {
			return;
		}
		onChange(e);
	};
	return (
		<div className={`${styles.container} ${fullWidth ? styles["container--fullWidth"] : ""}`}>
			{label && (
				<div className={`${styles.label} ${labelClassName}`}>
					{label}
					{required && <span className={styles.required}>*</span>}
				</div>
			)}
			<CustomTextField
				select
				className={`${styles.textField} ${className}`}
				disabled={disabled}
				error={error}
				fullWidth={fullWidth}
				iconcomponent={icon && <IconComponent icon={icon} />}
				InputProps={{
					className: textFieldClassName,
					classes: { input: inputClassName },
					notched: false,
				}}
				required={required}
				SelectProps={{
					MenuProps: { classes: { list: listClassName } },
					displayEmpty: !!placeholder,
					renderValue: (selected) => {
						if (
							selected === "" ||
							selected == null ||
							(typeof selected === "object" && Object.keys(selected).length === 0)
						) {
							return <span className={styles.placeholder}>{translate(placeholder) || placeholder}</span>;
						}
						return (
							(valueRenderer && valueRenderer(selected)) ||
							(field && selected?.[field]) ||
							selected?.[fallbackField] ||
							selected
						);
					},
					onClose: () =>
						setTimeout(() => {
							document.activeElement.blur();
						}, 0),
				}}
				size={size}
				translate={autoTranslate}
				value={value}
				variant="outlined"
				onChange={handleChange}
			>
				{withNone ? (
					<MenuItem value="">
						<div className={styles.textfield__item}>{translate("common:empty-state.none")}</div>
					</MenuItem>
				) : null}
				{Array.isArray(items) &&
					items.map((item) => {
						const key = item?.[field] || item?.[fallbackField] || item;
						const keyItem = item?.id;
						const extra = extraField && item?.[extraField] ? ` (${item[extraField]})` : "";
						return (
							<MenuItem
								key={keyItem || key}
								disabled={item.disabled || item.locked || (item.active !== undefined && !item.active)}
								value={item}
								{...filteredDataAttributes}
							>
								<CustomTooltip title={item.tooltip || ""}>
									<div
										className={styles.textfield__item}
										data-disabled={item.disabled}
										translate={autoTranslate}
									>
										{itemRenderer(`${key}${extra}`, item)}
									</div>
								</CustomTooltip>
							</MenuItem>
						);
					})}
			</CustomTextField>
		</div>
	);
}
